export const headerConst = {    
    GETPLATEFORMTYPE: 'GETPLATEFORMTYPE',
    ADDPLATEFORMTYPE: 'ADDPLATEFORMTYPE',
    GETROLETYPE: 'GETROLETYPE',
    SETUSERNAME: 'SETUSERNAME'
};
